import observer from '../components/utility/observer';

export default (): string => {
  const brandListElement = document.querySelector('.brand-list');
  if (brandListElement) {
    observer(brandListElement, 'brand-list').observe(brandListElement);
  }
  return null;
};
